import type { SVGProps } from 'react';

export const Menu = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.25 17.625a.799.799 0 0 1-.55-.2.766.766 0 0 1-.2-.525.8.8 0 0 1 .2-.55.748.748 0 0 1 .55-.225h15.5c.217 0 .392.075.525.225.15.15.225.333.225.55a.72.72 0 0 1-.225.525.71.71 0 0 1-.525.2H4.25Zm0-4.875a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h15.5c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2H4.25Zm0-4.875a.748.748 0 0 1-.55-.225.766.766 0 0 1-.2-.525.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h15.5c.217 0 .392.075.525.225.15.133.225.308.225.525a.72.72 0 0 1-.225.525.669.669 0 0 1-.525.225H4.25Z" />
    </svg>
  );
};
